module.exports = __webpack_public_path__ + "img/40_38_058_220.530b9301.jpg";